<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col md="8" lg="8" xl="6">
        <v-card>
          <v-card-title>
            <span class="font-weight-regular">{{ formTitle }}</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-progress-linear
            :active="loading"
            :indeterminate="loading"
          ></v-progress-linear>
          <v-card-text class="pa-5">
            <v-card outlined class="mb-5">
              <v-card-title>
                <v-checkbox hide-details class="pa-0 ma-0"></v-checkbox>
                <span class="font-weight-regular">สิทธิ์พนักงาน</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-checkbox
                  hide-details
                  class="mt-0"
                  label="อ่านข้อมูลพนักงาน"
                ></v-checkbox>
                <v-checkbox
                  hide-details
                  label="เขียนข้อมูลพนักงาน"
                ></v-checkbox>
                <v-checkbox
                  hide-details
                  label="แก้ไขข้อมูลพนักงาน"
                ></v-checkbox>
                <v-checkbox hide-details label="ลบข้อมูลพนักงาน"></v-checkbox>
              </v-card-text>
            </v-card>
            <v-card outlined class="mb-5">
              <v-card-title>
                <v-checkbox hide-details class="pa-0 ma-0"></v-checkbox>
                <span class="font-weight-regular">สิทธิ์ลูกค้า</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-checkbox
                  hide-details
                  class="mt-0"
                  label="อ่านข้อมูลลูกค้า"
                ></v-checkbox>
                <v-checkbox hide-details label="เขียนข้อมูลลูกค้า"></v-checkbox>
                <v-checkbox hide-details label="แก้ไขข้อมูลลูกค้า"></v-checkbox>
                <v-checkbox hide-details label="ลบข้อมูลลูกค้า"></v-checkbox>
              </v-card-text>
            </v-card>
            <v-btn class="mr-4" color="primary">ตกลง</v-btn>
            <v-btn :to="{ path: '/access-token' }">ยกเลิก</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="2" v-if="drawer"></v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent max-width="480px">
      <v-card>
        <v-card-title>
          <span>Access Token</span>
        </v-card-title>
        <v-card-text class="py-0">
          <v-text-field
            ref="textToCopy"
            v-model="accessToken"
            single-line
            append-icon="mdi-content-copy"
            hide-details
            class="mb-1"
            @click:append="copyAccessToken"
          ></v-text-field>
          <span class="caption red--text">{{ accessTokenMessage }}</span>
        </v-card-text>
        <v-card-actions class="d-flex justify-center pa-5">
          <v-btn @click="onCancel">ตกลง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      accessToken: '',
      accessTokenMessage: 'โปรดคัดลอก access token',
      formTitle: '',
      loading: false,
      name_th: '',
      name_en: '',
      modalDateExpire: false,
      expire: moment().add(1, 'year').format('YYYY-MM-DD'),
    }
  },
  computed: {
    drawer() {
      return this.$store.state.drawer
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'สิทธิ์ความปลอดภัย',
        disabled: false,
        to: '/access-token',
      },
      {
        text: 'กำหนดสิทธิ์การเข้าถึงข้อมูล',
        disabled: true,
      },
    ])

    this.formTitle = 'กำหนดสิทธิ์การเข้าถึงข้อมูล'
  },
  methods: {
    ...mapActions({
      createAccessToken: 'accessToken/createAccessToken',
    }),
    copyAccessToken() {
      let textToCopy = this.$refs.textToCopy.$el.querySelector('input')
      textToCopy.select()
      document.execCommand('copy')
    },
    onCancel() {
      this.$router.push({ path: '/access-token' })
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.loading = true

        const newAccessToken = {
          name_th: this.name_th,
          name_en: this.name_en,
          created: new Date(),
          expire: this.expire,
        }

        this.createAccessToken(newAccessToken)
          .then(({ key }) => {
            this.loading = false

            this.accessToken = key
            this.dialog = true
          })
          .catch((error) => {
            this.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    checkEmpty(value, field) {
      if (value) {
        this[field] = value.trim()
      }
    },
  },
}
</script>
